
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

/**
 * This component serves as a JSON API endpoint for getting agent data
 * It's used by the embed.js script to get agent information
 */
const PublicAgentAPI = () => {
  const { publicId } = useParams<{ publicId: string }>();
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    const fetchAndReturnData = async () => {
      // Set proper CORS headers immediately
      const corsHeaders = {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, OPTIONS',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization, x-client-info, apikey'
      };
      
      // Add CORS headers
      Object.entries(corsHeaders).forEach(([header, value]) => {
        const meta = document.createElement('meta');
        meta.setAttribute('http-equiv', header);
        meta.setAttribute('content', value);
        document.head.appendChild(meta);
      });
      
      if (!publicId) {
        sendJsonResponse({ error: "No agent ID provided" }, 400);
        return;
      }
      
      try {
        console.log("PublicAgentAPI: Fetching agent with public_id:", publicId);
        
        const { data, error } = await supabase.functions.invoke('get-public-agent', {
          body: { publicId }
        });
        
        if (error) {
          console.error("Error from Edge Function:", error);
          sendJsonResponse({ error: "Agent not found or inactive", details: error.message }, 404);
          return;
        }

        if (!data || !data.agent) {
          console.error("Invalid response from Edge Function:", data);
          sendJsonResponse({ error: "Agent not found or inactive" }, 404);
          return;
        }
        
        console.log("PublicAgentAPI: Received data from Edge Function:", data);
        
        // Return the data as JSON
        sendJsonResponse(data);
      } catch (error) {
        console.error("PublicAgentAPI: Error fetching agent data:", error);
        sendJsonResponse({ error: "Failed to fetch agent data", details: String(error) }, 500);
      }
    };
    
    fetchAndReturnData();
  }, [publicId]);
  
  function sendJsonResponse(data: any, status = 200) {
    // Set content type header
    const contentTypeMeta = document.createElement('meta');
    contentTypeMeta.setAttribute('http-equiv', 'Content-Type');
    contentTypeMeta.setAttribute('content', 'application/json');
    document.head.appendChild(contentTypeMeta);
    
    // Clear any existing HTML
    document.documentElement.innerHTML = '';
    
    // Write JSON response
    document.write(JSON.stringify(data, null, 2));
    
    // Set status code in window name (for debugging)
    window.name = `status-${status}`;
    
    setIsLoaded(true);
  }
  
  if (!isLoaded) {
    return null;
  }
  
  return null;
};

export default PublicAgentAPI;
